import type { DateRange } from "@repo/app-types/entities/dateRange";
import { IconFlagCheck } from "@tabler/icons-react";
import type { FC, ReactNode } from "react";
import { formatDateRangeWithWeekdays } from "../dateRange/formatDateRange.js";

export interface CoachingGoalHeaderProps {
  dateRange: DateRange;
  /**
   * The coaching-period selector, rendered on the right of the header. When
   * omitted, a static label for {@link dateRange} is shown instead.
   */
  periodSelector?: ReactNode;
}

export const CoachingGoalHeader: FC<CoachingGoalHeaderProps> = (props) => {
  const { dateRange, periodSelector } = props;

  return (
    <header className="flex flex-wrap items-center justify-between gap-3">
      <div className="flex min-w-0 items-center gap-2">
        <IconFlagCheck className="size-4 shrink-0 text-emerald-700" />
        <h2 className="text-sm leading-5 font-semibold text-foreground">
          Weekly coaching goal
        </h2>
      </div>

      {periodSelector ?? (
        <p className="text-sm leading-5 font-medium text-muted-foreground">
          {formatDateRangeWithWeekdays(dateRange)}
        </p>
      )}
    </header>
  );
};
